import { api } from '@/services/api';
import { useToast } from '@/hooks/useToast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GET_ASSET_QUERY_KEY } from './useGetAsset';
import { GET_SUPPLEMENTAL_ASSETS_QUERY_KEY } from './useGetSupplementalAssets';

export const useReprocessManifestCriticalGeometry = () => {
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  const { mutate, mutateAsync, isPending } = useMutation({
    mutationKey: ['reprocessManifestCriticalGeometry'],
    mutationFn: ({ tenantId, assetId }: { tenantId: string; assetId: string }) =>
      api.assets.putManifestCriticalGeometry(tenantId, assetId),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: [GET_ASSET_QUERY_KEY], exact: false });
      queryClient.resetQueries({ queryKey: [GET_SUPPLEMENTAL_ASSETS_QUERY_KEY], exact: false });
      showToast({ message: 'Critical geometry manifest assembly updated', type: 'success' });
    },
    onError: () => {
      showToast({ message: 'Failed to update critical geometry', type: 'error' });
    },
  });

  return {
    reprocessManifestCriticalGeometry: mutate,
    reprocessManifestCriticalGeometryAsync: mutateAsync,
    isPending,
  };
};
